'use client';

import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from 'components/shared/custom-image/CustomImage';
import styles from './PhotonInTheBox.module.css';

const getData = (t: (key: string) => string) => [
  {
    image: 'web_v2/photon/whats-in-the-box/photon-1.png/w_800',
    title: t('photon.photonInTheBox.image.photon'),
  },
  {
    // Box ships the USB-C cable only, no wall adapter or plug heads.
    image: 'web_v2/photon/whats-in-the-box/cable.png/w_800',
    title: t('photon.photonInTheBox.image.usbCable'),
  },
  {
    image: 'web_v2/photon/whats-in-the-box/case-1.png/w_800',
    title: t('photon.photonInTheBox.image.travelCase'),
  },
];

export const PhotonInTheBox = ({
  className,
  htmlId,
}: {
  className?: string;
  htmlId?: string;
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const t = useTranslations('photon');
  const data = getData(t);

  return (
    <div
      className={`${styles.root} u-grid${className ? ` ${className}` : ''}`}
      id={htmlId}
      ref={rootRef}
    >
      <div>
        <h2 className={`${styles.heading} title`}>
          {t('photon.photonInTheBox.heading.whatsInTheBox')}
        </h2>
        <div className={`${styles.contents} u-hide-scrollbar`}>
          {data.map((element, index) => (
            <div key={index} className={styles.boxContentElementWrapper}>
              <div className={styles.boxContentElement}>
                <Image
                  src={element.image}
                  alt={element.title}
                  width="200"
                  height="200"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhotonInTheBox;
